<template>
<div class="content">
<div style="text-align: right; width: 100%"><el-button type="primary" @click="addOrUpdateHandler" v-if="role == '管理员'">编辑公司制度</el-button></div>
<div v-html="htmlContent"></div>

  <el-dialog
      title="编辑公司制度"
      :visible.sync="dialogVisible"
      width="50%">
      <editor
          style="width: 100%"
          v-model="editContent"
          class="editor"
          action="file/upload">
      </editor>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="save">保 存</el-button>
  </span>
  </el-dialog>
</div>

</template>
<script>
import router from '@/router/router-static'
import AddOrUpdate from "@/views/modules/config/add-or-update.vue";
export default {
  data() {
    return {
      htmlContent: '',
      editContent: '',
      dialogVisible: false,
      ruleForm: {
        id:'',
        name: '',
        value: '',
      },
      role: ''
    }
  },
  mounted(){
    this.init();
  },

  methods:{
    init(){
        if(this.$storage.get('Token')){
        this.$http({
            url: `${this.$storage.get('sessionTable')}/session`,
            method: "get"
        }).then(({ data }) => {
            if (data && data.code != 0) {
            router.push({ name: 'login' })
            }
        });
        }else{
            router.push({ name: 'login' })
        }
      this.role = this.$storage.get('role');
        //取数据
      this.$http({
        url: `config/info/7`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.ruleForm = data.data;
          this.htmlContent = data.data.value;
        }
      })
    },
    addOrUpdateHandler() {
      this.editContent = this.htmlContent;
      this.dialogVisible = true
    },
    save() {
      this.htmlContent = this.editContent;
      this.ruleForm.value = this.editContent;
      this.$http({
        url: `config/update`,
        method: "post",
        data: this.ruleForm
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message({
            message: "操作成功",
            type: "success",
            duration: 1500,
            onClose: () => {
              this.parent.showFlag = true;
              this.parent.addOrUpdateFlag = false;
              this.parent.configCrossAddOrUpdateFlag = false;
              this.parent.search();
              this.parent.contentStyleChange();
            }
          });
        } else {
          this.$message.error(data.msg);
        }
      });
      this.dialogVisible = false
    }
  }
};
</script>
<style>
h1 {
  font-size: 3.5em;
}
.ql-align-center {
  text-align: center;
}
</style>
<style lang="scss" scoped>
.content {
  width: 100%;
  height: 80%;
  overflow: auto;
}
</style>